/**
 * Generates a unique GUID
 * it directly taken from nielsens documentation
 * https://engineeringportal.nielsen.com/docs/DCR_Denmark_Video_Cloud_API#Create_Session_ID
 *
 */
export function buildGUID() {
  const UAIDbase62Characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const UAIDpayloadLength = 29;

  function UAIDgetRandom62() {
    let r1;
    do {
      r1 = Math.floor(Math.random() * (16 * 62));
    } while (r1 > 61);
    return r1;
  }

  let uid = '';
  for (let a = 0; a < UAIDpayloadLength; a += 1) {
    uid += UAIDbase62Characters.charAt(UAIDgetRandom62());
  }
  uid += Math.floor(new Date().getTime() / 1000);
  return uid;
}
